import rootLogger from '@/utils/root-logger';

const logger = rootLogger.create('storage');

export function Storage(source) {
  this.getItem = (key, defaultValue, storeDefault = true) => {
    const storedItem = source && source.getItem(key);
    if (!storedItem && defaultValue) {
      if (storeDefault) {
        this.setItem(key, defaultValue);
      }
      return defaultValue;
    }
    return storedItem;
  };

  this.canSet = () => {
    const testKey = Date.now;
    try {
      source.setItem(testKey, testKey);
      // no exception, storage is writable
      source.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  this.setItem = (key, value) => {
    try {
      if (source) {
        source.setItem(key, value);
      }
    } catch (error) {
      logger.debug('cannot set item', {key, error});
    }
  };

  this.removeItem = (key) => {
    try {
      source.removeItem(key);
    } catch (error) {
      logger.debug('cannot remove item', {key, error});
    }
  };
}

export const sessionStorage = new Storage(window.sessionStorage);
export const localStorage = new Storage(window.localStorage);
